import { render } from "./BreadcrumbsNav.vue?vue&type=template&id=7ad7b1a4"
import script from "./BreadcrumbsNav.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__